/**
 * Capstone article CSS-only carousels (.capstone-slider) use hidden radio inputs.
 * Clicking arrow/nav labels focuses those inputs at the top of the slider,
 * which scrolls the page upward. Handle slide changes without moving focus.
 */
(function () {
  function activateRadio(radio) {
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindCapstoneSliders(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('.capstone-slider');

    sliders.forEach(function (slider) {
      slider.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.tabIndex = -1;
      });

      slider.querySelectorAll('label[for]').forEach(function (label) {
        if (label.dataset.capstoneSliderBound === '1') return;
        label.dataset.capstoneSliderBound = '1';

        label.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });

        label.addEventListener('click', function (e) {
          e.preventDefault();
          var id = label.getAttribute('for');
          if (!id) return;
          var radio = slider.querySelector('#' + CSS.escape(id));
          activateRadio(radio);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCapstoneSliders();
    });
  } else {
    bindCapstoneSliders();
  }

  document.addEventListener('shopify:section:load', function (e) {
    bindCapstoneSliders(e.target);
  });
})();
